import styled from '@/styles';

const Circle = styled('span', {
  display: 'inline-flex',
  width: '18px',
  height: '18px',
  borderRadius: '50%',
  alignItems: 'center',
  justifyContent: 'center',
  variants: {
    cleared: {
      true: { color: '#1E8E3E' },
      false: { color: '#BDBDBD' },
    },
  },
});

const StatusIcon = ({
  cleared,
  testId,
  label,
}: {
  cleared: boolean;
  testId: string;
  label: string;
}) => (
  <Circle
    cleared={cleared}
    data-testid={testId}
    data-cleared={cleared ? 'true' : 'false'}
    role="img"
    aria-label={label}
  >
    <svg
      width="18"
      height="18"
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden="true"
    >
      <circle
        cx="10"
        cy="10"
        r="8.5"
        stroke="currentColor"
        strokeWidth="1.5"
        fill={cleared ? 'currentColor' : 'none'}
      />
      <path
        d="M6.5 10.2l2.3 2.3 4.7-4.7"
        stroke={cleared ? '#FFFFFF' : 'currentColor'}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Circle>
);

export default StatusIcon;
